import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'lc-protective-clean-page',
  templateUrl: './protective-clean-page.component.html',
  styleUrls: ['./protective-clean-page.component.scss']
})
export class ProtectiveCleanPageComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }

  goto_shop_detail(){
    // this.dataService.show_shop = true;
    this.router.navigateByUrl('/shop/detail/HX6848%2F92');
  }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/pages/protective-clean-page/protective-clean-page.component.ts